/**
 * IapDiagnosticsPanel — TEMPORARY on-screen diagnostic for the iOS paywall.
 *
 * Only rendered when `isIapDiagnosticsEnabled()` is true. Shows no secrets,
 * tokens, JWS or user data.
 */
import {
  classifyIapDiagnostics,
  isIapDiagnosticsEnabled,
  IAP_DIAGNOSTICS_CASE_LABEL,
  type IapDiagnosticsSnapshot,
} from "@/lib/iap/diagnostics";

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-start justify-between gap-3">
      <span className="text-muted-foreground">{label}</span>
      <span className="text-right font-medium text-foreground break-all">{value}</span>
    </div>
  );
}

export function IapDiagnosticsPanel({
  snapshot,
}: {
  snapshot: IapDiagnosticsSnapshot;
}) {
  if (!isIapDiagnosticsEnabled(snapshot.isNativeIOS)) return null;

  const diagCase = classifyIapDiagnostics(snapshot);

  return (
    <div
      className="rounded-lg border border-dashed border-border bg-muted/40 p-3 text-[11px] leading-relaxed space-y-1"
      data-testid="iap-diagnostics-panel"
      data-diagnostic-case={diagCase}
    >
      <p className="text-xs font-semibold text-foreground" data-testid="iap-diagnostics-active">
        IAP DIAGNOSTICS ACTIVE
      </p>
      <p className="text-xs font-medium text-primary">
        {IAP_DIAGNOSTICS_CASE_LABEL[diagCase]}
      </p>
      <div className="pt-1 space-y-0.5">
        <Row label="isNativeIOS" value={String(snapshot.isNativeIOS)} />
        <Row label="VITE_IAP_APPLE_ENABLED" value={String(snapshot.flagEnabled)} />
        <Row
          label='Capacitor.isPluginAvailable("MBLearnIap")'
          value={String(snapshot.capacitorPluginAvailable)}
        />
        <Row
          label="plugin respondió isAvailable"
          value={snapshot.probing ? "probing…" : String(snapshot.pluginAvailable)}
        />
        <Row label="respuesta del probe recibida" value={snapshot.nativeProbeResponded ? "sí" : "no"} />
        <Row label="getProducts iniciada" value={snapshot.getProductsStarted ? "sí" : "no"} />
        <Row label="respuesta getProducts recibida" value={snapshot.getProductsResponseReceived ? "sí" : "no"} />
        <Row label="IDs solicitados" value={snapshot.requestedProductIds.join(", ") || "—"} />
        <Row label="IDs devueltos" value={snapshot.returnedProductIds.join(", ") || "—"} />
        <Row label="productos recibidos" value={String(snapshot.productCount)} />
        <Row label="error del plugin" value={snapshot.errorDetail ?? "—"} />
        <Row label="storeKitReady" value={String(snapshot.storeKitReady)} />
        <Row label="uiState" value={snapshot.uiState ?? "—"} />
      </div>
    </div>
  );
}

export default IapDiagnosticsPanel;
